const DEVELOPMENT = 'development';
const PRODUCTION = 'production';
const TEST = 'test';

const {ADMIN, ANALYTICS, API_URL, BACKEND, DEV_TOOLS_ON_STARTUP, ENTERPRISE, OAUTH_ENABLED, OMNIBAR, NODE_ENV, STORYBOOK_ENV} = CONFIG;
let omnibar: boolean = OMNIBAR !== null ? OMNIBAR : true;

interface DesktopConfig {
    /**
     * The name of the organization that this desktop belongs to - used to determine if the launcher is running in
     * an "enterprise" context.
     */
    org?: string;
}

export const getBackend = () => {
    let backend = BACKEND;
    if (!BACKEND.endsWith('/')) {
        backend += '/';
    }
    return backend;
};

export const getApiUrl = () => {
    if (API_URL) {
        return API_URL;
    }

    return window && window.location && window.location.origin ? `${window.location.origin}/` : '/';
};
export const hasDevToolsOnStartup = () => DEV_TOOLS_ON_STARTUP;
export const isAnalyticsEnvOn = () => ANALYTICS;
export const isDevelopmentEnv = () => NODE_ENV === DEVELOPMENT;
export const isEnterpriseEnv = () => ENTERPRISE;
export const isEnterpriseAdmin = () => ENTERPRISE && ADMIN;
export const isOauthEnabled = () => OAUTH_ENABLED;
export const isProductionEnv = () => NODE_ENV === PRODUCTION;
export const isStorybookEnv = () => STORYBOOK_ENV;
export const isTestEnv = () => NODE_ENV === TEST;
export const isOmnibar = () => omnibar;

/**
 * For any parameters that require async initialisation, perform that here.
 *
 * This MUST resolve before attempting to use any of these config params.
 */
export async function initConfig() {
    if (OMNIBAR === null) {
        const config = await getDesktopOwnerConfig();
        const orgName = config && config.org;

        // Use omnibar mode, unless desktop config exists AND declares an org name
        omnibar = !orgName;
    }
}

async function getDesktopOwnerConfig(): Promise<DesktopConfig | null> {
    const desktopConfig = await Promise.race([
        fin.System.getServiceConfiguration({name: 'suite'}).catch(() => null),
        new Promise<null>((resolve) => setTimeout(() => resolve(null), 1000))
    ]);

    return desktopConfig && desktopConfig.config as DesktopConfig;
}
